export default __webpack_public_path__ + "static/media/wind.1a401ebc.svg";